/**
 * Model for a wrestlers waiver agreement.
 */
export class WrestlerWaiver {
    public id: string = null;
    public signature: string = null;
    public initials: string = null;

    public clone(): WrestlerWaiver {
        const clone: WrestlerWaiver = new WrestlerWaiver();
        clone.id = this.id;
        clone.signature = this.signature;
        clone.initials = this.initials;
        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'wrestlerWaiver';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.signature = this.signature;
        json.data.attributes.initials = this.initials;
        return JSON.stringify(json);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): WrestlerWaiver {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.signature = attrs['signature'];
        this.initials = attrs['initials'];

        return this;
    }
}
